export const normes = {
  normes: 'Normes',
  normesMinimal: 'Normes minimales',
};
